import { Box } from '@chakra-ui/layout'
import { } from 'containers'
import { connectNetwork } from 'lib/NetworkProvider'
import { routes, route_from } from 'lib/routes'
import View from 'lib/View'
import moment from 'momentconfig'
import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Icon, Input, Select, Table } from 'semantic-ui-react'
import { Confirmation, ImageDefault } from '.'
import { floatTimeToString, timeString } from '../lib/util'

const { app, badges, badgeEdit } = routes

class Badge extends Component {
    constructor(props) {
        super(props)

        this.componentContainerRef = null

        this.setComponentContainerRef = (element) => {
            this.componentContainerRef = element
        }

        let { onCostChange, badge } = props

        this.state = {
            colors: ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'],
            deleting: false,
            ...badge,
            badgeMinutes: badge ? parseFloat(badge.badgeMinutes) : 0,
        }

        if (onCostChange && badge) {
            onCostChange(this.totalCost(), badge.id)
        }
    }

    totalCost() {
        let { badgeHourlyRate, badgeHours, badgeMinutes } = this.state
        let total = (badgeHours + badgeMinutes / 60) * parseFloat(badgeHourlyRate)
        if (isNaN(total)) {
            total = 0
        }
        return total
    }

    componentDidMount() {
        let { badge, id, network } = this.props

        if ((!badge || !badge.id) && id) {
            network.getBadge(id)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { onCostChange, getBadge, login } = this.props
        let { id, badgeHourlyRate } = this.state
        if (badgeHourlyRate !== prevState.badgeHourlyRate) {
            if (onCostChange) {
                onCostChange(this.totalCost(), id)
            }
        }

        // console.log('Badge getBadge fetching', getBadge.fetching)
        if (getBadge && getBadge.fetching !== prevProps.getBadge.fetching && !getBadge.fetching) {
            // console.log('Done calling getBadge')
            if (getBadge.status.success) {
                // console.log(getBadge.data)
                let badge = getBadge.data.data

                this.setState({ ...badge })
                // console.log('Calling Get badge', login, badge)
                /*
				if (login && login.data.user && login.data.user.companies) {
					let company = login.data.user.companies[organization.data[0]]
					// console.log('Calling getFromIdFiltering', company, jobId)
					network.getFromIdFiltering(company, jobId, [
						{
							key: 'timestamp',
							symbol: '>',
							value: moment().subtract(4, 'hours').format('YYYY-MM-DD HH:mm:ss')
						}
					])
				}*/
                return
            } else {
                // console.log('calling No badge found with this id')
            }
        }
    }

    renderBalanceFooter() {
        let { hourtotal, total } = this.props

        let averageHourlyCost = Math.round((total / hourtotal) * 100) / 100
        if (isNaN(averageHourlyCost)) {
            averageHourlyCost = '--'
        }

        return (
            <Table.Row>
                <Table.Cell width="5">Prezzo orario medio: {averageHourlyCost}€/h</Table.Cell>
                <Table.Cell style={{ textAlign: 'right' }} width="4">
                    Totale Ore:
                </Table.Cell>
                <Table.Cell width="4">{floatTimeToString(hourtotal)}</Table.Cell>
                <Table.Cell width="1">Totale:</Table.Cell>
                <Table.Cell width="2">{total}€</Table.Cell>
            </Table.Row>
        )
    }

    renderBalanceHeader() {
        return (
            <Table.Header fullWidth>
                <Table.Row>
                    <Table.HeaderCell width="5">Nome Macchina</Table.HeaderCell>
                    <Table.HeaderCell width="4">Prezzo €/h</Table.HeaderCell>
                    <Table.HeaderCell width="4">Ore di lavoro</Table.HeaderCell>
                    <Table.HeaderCell width="1" />
                    <Table.HeaderCell width="2">Totale</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
        )
    }

    renderForBalance() {
        let { name, badgeHourlyRate, badgeHours, badgeMinutes } = this.state
        return (
            <Table.Row>
                <Table.Cell>{name}</Table.Cell>
                <Table.Cell>
                    <span className="no-print">
                        <Input
                            type="number"
                            step="0.01"
                            value={badgeHourlyRate}
                            onChange={(e, data) => {
                                let value = data.value
                                if (value < 0) value = 0
                                this.setState({
                                    badgeHourlyRate: value,
                                })
                            }}
                        />
                        €/h
                    </span>
                    <span className="only-print">{badgeHourlyRate}€/h</span>
                </Table.Cell>
                <Table.Cell>{timeString(badgeHours, badgeMinutes)}</Table.Cell>
                <Table.Cell>=</Table.Cell>
                <Table.Cell>{this.totalCost()}€</Table.Cell>
            </Table.Row>
        )
    }

    renderTableFooter() {
        let { isBalance } = this.props
        if (isBalance) return this.renderBalanceFooter()
        else return null
    }

    renderTableHeader() {
        let { hideBadge, hideWorker, isBalance } = this.props
        if (isBalance) {
            return this.renderBalanceHeader()
        } else {
            return (
                <Table.Header fullWidth>
                    <Table.Row>
                        {!hideBadge && <Table.HeaderCell>Identificativo Badge</Table.HeaderCell>}
                        {!hideWorker && <Table.HeaderCell>Impiegato associato</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>
            )
        }
    }

    renderForTable() {
        let { hideBadge, hideWorker, isBalance, workeroptions, network } = this.props
        let { badgeCode, workerId, workerName } = this.state

        // console.log('workeroptions', workeroptions)

        if (isBalance) {
            return this.renderForBalance()
        } else {
            return (
                <Table.Row>
                    {!hideBadge && <Table.Cell>{badgeCode}</Table.Cell>}
                    {!hideWorker && (
                        <Table.Cell>
                            <Select
                                value={workerId}
                                placeholder="Impiegato"
                                options={workeroptions}
                                onChange={(value, selection, b, c) => {
                                    // console.log('Impiegato selected', selection.value)
                                    const id = selection.value
                                    network
                                        .createBadge({
                                            badgeCode,
                                            workerId: id,
                                        })
                                        .then((result) => {
                                            network.getBadgeList(this.props.search.data)
                                        })
                                }}
                            ></Select>
                        </Table.Cell>
                    )}
                </Table.Row>
            )
        }
    }

    openRemoveDialog() {
        this.setState({ deleting: true })
    }

    remove() {
        let { network, badge } = this.props

        network.deleteBadge(badge)

        this.setState({ deleting: false })
    }

    render() {
        let { login, type, badge, onClick, selected, noActions, traversable } = this.props
        let { deleting, badgeId: id, badgeName, badgeDescription, badgeImages } = this.state

        let extraprops = {
            fluid: type === 'full' ? true : false,
        }

        if (onClick) {
            extraprops.onClick = () => {
                onClick(badge)
            }
        }

        let col = parseInt(Math.random() * this.state.colors.length)

        let user = null
        if (login && login.authenticated) {
            user = login.data.user
        }

        switch (type) {
            case 'footer':
                return this.renderTableFooter()
            case 'header':
                return this.renderTableHeader()
            case 'table':
                return this.renderForTable()
            case 'compact':
                return (
                    <div ref={this.setComponentContainerRef}>
                        <Box style={{ height: 200, width: 200 }}>
                            <Box textStyle="header">Badge compact {badgeName}</Box>
                        </Box>
                    </div>
                )
            default:
                return (
                    <View fullw column between>
                        <Box borderWidth="1px" borderRadius="lg"
                    p="4" overflow="hidden" className={selected ? 'rowSelected' : ''} style={styles.badgeCard} {...extraprops} >
                            <Confirmation
                                message="Vuoi davvero eliminare questa collezione?"
                                showModal={deleting}
                                onConfirm={() => {
                                    this.remove()
                                }}
                                onCancel={() => {
                                    this.setState({ deleting: false })
                                }}
                            />
                            <Box textStyle="content" style={styles.badgeContent}>
                                <View fullw row>
                                    {badgeImages && badgeImages.length > 0 && (
                                        <div style={styles.imageContainer}>
                                            <ImageDefault fromRoot src={badgeImages[0].picturePath} ui={false} style={styles.badgeImage} />
                                        </div>
                                    )}
                                    {!badgeImages ||
                                        (badgeImages.length === 0 && (
                                            <div style={styles.imageContainer}>
                                                <ImageDefault fromRoot src={null} ui={false} style={styles.badgeImage} />
                                            </div>
                                        ))}
                                    <View fullw column>
                                        <span style={styles.header}>{badgeName}</span>
                                        <Box textStyle="description">{badgeDescription}</Box>
                                    </View>
                                </View>
                            </Box>
                            {!noActions && (
                                <Box textStyle="content" extra>
                                    {user && !!user.manage_badge && (
                                        <Button
                                            color="blue"
                                            onClick={() => {
                                                this.props.history.push(route_from(app, badges, badgeEdit, `${id}`))
                                            }}
                                        >
                                            <Icon name="edit" />
                                            Modifica
                                        </Button>
                                    )}

                                    {user && !!user.manage_badge && (
                                        <Button
                                            color="red"
                                            onClick={() => {
                                                this.openRemoveDialog()
                                            }}
                                        >
                                            <Icon name="delete" />
                                            Elimina
                                        </Button>
                                    )}
                                </Box>
                            )}
                            {traversable && (
                                <Box textStyle="content" extra>
                                    <Button
                                        color="blue"
                                        onClick={() => {
                                            this.props.onTraverse(badge)
                                        }}
                                    >
                                        <Icon name="folder" />
                                        Apri
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </View>
                )
        }
    }
}

const styles = {
    header: {
        fontSize: '32pt',
        lineHeight: 'normal',
    },
    imageContainer: {
        minWidth: 200,
        minHeight: 150,
        marginRight: 28,
    },
    badgeImage: {
        width: 200,
        height: 150,
        objectFit: 'contain',
    },
    badgeContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    badgeCard: {
        marginTop: 8,
        marginBottom: 8,
    },
}

const mapStateToProps = (state) => {
    let {
        login,
        getBadge,
        getWorkerList: {
            fetching: fetchWorkers,
            data: { data: workers },
        },
        search,
    } = state
    let rcode = null
    if (login && login.data && login.data.user) rcode = login.data.user.rcode

    let options = []
    for (let i in workers) {
        let worker = workers[i]
        options.push({
            key: worker.workerId,
            text: worker.workerName,
            value: worker.workerId,
        })
    }

    return { role: rcode, getBadge, login, fetchWorkers, workers, workeroptions: options, search }
}

export default withRouter(connect(mapStateToProps)(connectNetwork(Badge)))
